import { Link } from 'react-router';
import SocialLinks from './SocialLinks';
import { contactMailto } from '../config/links';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <p className="site-footer__copyright">
          {`© ${new Date().getFullYear()} ShareShutter. All rights reserved.`}
        </p>

        <div className="site-footer__links">
          <nav className="site-footer__legal" aria-label="Footer">
            <Link className="text-link" to="/privacy">
              Privacy Policy
            </Link>
            <Link className="text-link" to="/terms">
              Terms of Use
            </Link>
            {/* A mailto rather than a form: there is no backend on this site,
                and a form that silently drops messages is worse than none. */}
            <a className="text-link" href={contactMailto}>
              Contact Us
            </a>
          </nav>
          <SocialLinks />
        </div>
      </div>
    </footer>
  );
}
